import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-164">
      <div className="bg-white rounded-[20px] p-7 sm:p-9 max-w-[660px] mx-auto text-center shadow-[0_6px_30px_rgba(0,0,0,0.08)] border-2 border-verde" data-id="element-165">
        <div className="text-[48px] mb-4 flex justify-center" data-id="element-166">
          <ShieldCheck size={48} className="text-verde" data-id="element-167" />
        </div>
        <h3 className="text-[22px] font-extrabold text-oscuro mb-3" data-id="element-168">
          7 DÍAS DE GARANTÍA TOTAL
        </h3>
        <p className="text-[14px] text-gris leading-[1.65]" data-id="element-169">
          Abrís los tomos, probás las plantillas en tu próximo turno. Si no es
          lo que esperabas:{' '}
          <strong className="text-oscuro" data-id="element-170">
            sin preguntas, sin formularios, sin drama
          </strong>{' '}
          — te devolvemos el 100% de lo que pagaste.
          <br data-id="element-171" />
          <br data-id="element-172" />
          Eso es lo confiadas que estamos en el resultado.
        </p>
        <p className="mt-3 text-[12px] text-gris" data-id="element-173">
          (Tasa de devoluciones menor al 1%)
        </p>
      </div>
    </section>;
}